const logging = {
  fetchedBases: false,
  fetchedGames: false,
  fetchedVersions: false,
  selections: true,
  savedVersion: true,
};

const config = {
  // Served with the dashboard; may also point to an HTTPS static review host.
  playableReviewUrl: "/review/index.html",
  backendPort: 3000,
  loggingLevel: 3,
  logging,
};

export default config;
